import { Component, OnInit } from '@angular/core';
import { CommsService } from '../../services/comms/comms.service';
import { NoteService } from '../../services/note/note.service';
import { DisplayService } from '../../services/display/display.service';
import { ConfigService } from '../../services/config/config.service';

@Component({
	selector: 'pcm-sa-config',
	templateUrl: './sa-config.component.html',
	styleUrls: ['./sa-config.component.scss']
})
export class SaConfigComponent implements OnInit {
	submission;
	escalation;
	approval;

	configs = ['TIMESHEET_DEADLINE', 'LATE_TIMESHEET_ESC', 'TIMESHEET_APPROVAL_DEADLINE'];

	constructor(
		private commsService: CommsService,
		private noteService: NoteService,
		private displayService: DisplayService,
		private configService: ConfigService) {}
	ngOnInit() {
		this.init();
	}

	init() {
		this.submission = {
			day: 'Friday',
			time: {hour: 12, minute: 0},
			timezone: {name: 'EDT/EST', value: 'America/New_York'}
		};
		this.escalation = {
			day: 'Friday',
			time: {hour: 12, minute: 0},
			timezone: {name: 'EDT/EST', value: 'America/New_York'}
		};
		this.approval = {
			day: 'Friday',
			time: {hour: 12, minute: 0},
			timezone: {name: 'EDT/EST', value: 'America/New_York'},
			week: true
		};
		const self = this;
		this.displayService.startLoading();
		let count = 0;
		this.configs.forEach(key => {
			this.commsService.retrieveConfig(key).subscribe(res => {
				const successData = self.commsService.getSuccessData(res);
				count += 1;
				if (successData.value) {
					// need convert to day-time model
					switch (successData.key) {
						case 'TIMESHEET_DEADLINE':
							self.submission = self.parseValue(successData.value);
							break;
						case 'LATE_TIMESHEET_ESC':
							self.escalation = self.parseValue(successData.value);
							break;
						case 'TIMESHEET_APPROVAL_DEADLINE':
							self.approval = self.parseValue(successData.value);
							self.approval['week'] = successData.week && successData.week.toLowerCase() === 'next' ? true : false;
							break;
					}
				}
				if (count === this.configs.length) {
					this.displayService.endLoading();
				}
			}, err => {
				count += 1;
				if (count === this.configs.length) {
					this.displayService.endLoading();
				}
				console.log(err);
				this.noteService.displayError('Error occurred during retrieving configurations.');
			});
		});
	}

	parseValue(value) {
		const valueTZ = this.configService.timezones.filter(tz => {
			return tz.value === value.timezone;
		});

		const valueHr = value.time ? parseInt(value.time) : 0;
		const model = {
			day: value.day,
			// eslint-disable-next-line radix
			time: {hour: valueHr, minute: 0},
			timezone: {name: valueTZ[0]['name'], value: value.timezone}
		};
		return model;
	}

	parseModel(model) {
		const modelHour = model.time && model.time.hour ? model.time.hour.toString() : 0;
		const value = {
			day: model.day,
			time: modelHour,
			timezone: model.timezone.value
		};
		return value;
	}

	submitConfigs() {
		const self = this;
		let count = 0;
		this.configs.forEach(configKey => {
			const body = {
				key: configKey,
				type: configKey,
				value: {}
			};
			// need convert to backend value json
			switch (configKey) {
				case 'TIMESHEET_DEADLINE':
					body.value = self.parseModel(self.submission);
					break;
				case 'LATE_TIMESHEET_ESC':
					body.value = self.parseModel(self.escalation);
					break;
				case 'TIMESHEET_APPROVAL_DEADLINE':
					body.value = self.parseModel(self.approval);
					body['week'] = self.approval.week ? 'next' : 'current';
					break;
			}
			this.commsService.recordConfig(body).subscribe(res => {
				count += 1;
				if (count === this.configs.length) {
					this.displayService.endLoading();
					this.noteService.displaySuccess('The new configurations have been successfully recorded.');
				}
			}, err => {
				count += 1;
				if (count === this.configs.length) {
					this.displayService.endLoading();
				}
				console.log(err);
				this.noteService.displayError('Error occurred during recording configurations.');
			});
		});

	}

	resetConfigs() {
		this.init();
	}
}
